import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";

export const REGEN_ZONES: Layer = {
  id: "regeneration_zones",
  layerType: ConstraintsLayerType,
  title: "Regeneration zones",
  requiredFeatureAccess: [Feature.planningPolicyLayer],
  toggleable: true,
  group: LayerGroup.STRATEGIC,
  icon: "lt-layer-regeneration-zones",
  description: "Revitalisation and redevelopment opportunities",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 10,
  },
  layerConfig: {
    rootCategory: ConstraintsCategory.DEVELOPMENT_SITES,
    categorySchema: [{ key: "area_action_plans" }, { key: "named_regeneration_area" }],
    statusSchema: ["adopted", "draft"],
  },
};
